import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation, input, computed } from "@angular/core";
import { DatePipe, NgOptimizedImage } from "@angular/common";
import { CardViewModel } from "../../models/card.vm";
import { RouterModule } from "@angular/router";

@Component({
    selector: "in2-card-box",
    imports: [DatePipe, NgOptimizedImage, RouterModule],
    templateUrl: "./card-box.component.html",
    styleUrls: ["./card-box.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "[class]": "classList()",
    },
})
export class CardBoxComponent {
    classList = input("");

    @ViewChild("cardContainer") cardContainer!: ElementRef;

    card = input.required<CardViewModel>();
    index = input(0);
    src = computed(() => {
        return this.card()?.img?.src || "";
    });
    behavior = computed(() => {
        const link = this.card()?.link;
        if (!link) return null;
        if (typeof link === "string" && link.length) return "link";
        return "emit";
    });
}
